<template>
 <div>
    <div class="searchBox" ref="searchBox">
      <el-form :inline="true" :model="searchFrom" ref="searchFrom" class="demo-form-inline" label-width="100px" size="mini">
        <div class="searchBox inpBox">
            <div class="item">
              <el-form-item label="运单号:" prop="wayNo">
                <el-input  placeholder="" v-model="searchFrom.wayNo"></el-input>
              </el-form-item>
              <el-form-item label="异常类型 :" prop="reportType">
                <el-select v-model="searchFrom.reportType" placeholder="请选择">
                  <el-option v-for="val in yclx" :label="val.name" :value="val.val" :key="val.val"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="车牌号:" prop="vhcNo">
                <el-input  placeholder="" v-model="searchFrom.vhcNo"></el-input>
              </el-form-item>
              <el-form-item label="司机姓名:" prop="dirverName">
                <el-input  placeholder="" v-model="searchFrom.dirverName"></el-input>
              </el-form-item>
              <el-form-item label="上报时间:" prop="reportDateTime">
                <el-date-picker
                  v-model="reportDateTime"
                  format="yyyy-MM-dd HH:mm:ss"
                  value-format="yyyy-MM-dd HH:mm:ss"
                  type="datetimerange"
                  range-separator="至"
                  start-placeholder="开始日期"
                  end-placeholder="结束日期"
                ></el-date-picker>
              </el-form-item>
              <el-form-item label="订单号:" prop="orderNo">
                <el-input  placeholder="" v-model="searchFrom.orderNo"></el-input>
              </el-form-item>
            </div>
        </div>
       <div class="searchBtnBox">
         <el-form-item btnCode="009M0I0100" v-if="btnFlg[0]">
            <el-button type="primary" @click="searchFn">查询</el-button>
          </el-form-item>
          <el-form-item btnCode="009M0I0200" v-if="btnFlg[1]">
            <el-button type="primary" @click="resetForm('searchFrom')">重置</el-button>
          </el-form-item>
          <el-form-item btnCode="009M0I0300" v-if="btnFlg[2]">
            <el-button type="primary"   @click="exportFn" :disabled="isDisable">导出</el-button>
          </el-form-item>
       </div>
      </el-form>
    </div>
    <!-- 表格 -->
    <div :style="{height:h}">
      <el-table :data="tableList"  ref="table" v-loading="loading" @row-click="handleRowClick"    bordersize="mini"
      class="table" height="100%" style="width: 100%" center border >
        <el-table-column label="操作"  width="100">
            <template slot-scope="scope">
              <div>
              <el-button type="text" size="mini" @click="lookImage(scope.row)">查看图片</el-button>
           </div>
            </template>
        </el-table-column>
        <el-table-column fixed type="index"  width="55" label="序号"></el-table-column>
        <el-table-column property="wayNo" width="200" label="运单号"></el-table-column>
        <!-- <el-table-column label="运单号" width="200">
          <template slot-scope="scope">
            <span style="color: #0c46a2;cursor: pointer;" @click="detailFn(scope.row)">{{scope.row.wayNo}}</span>
          </template>
        </el-table-column> -->
        <el-table-column property="reportType" width="120" :formatter="emptyFn" label="异常类型"></el-table-column>
        <el-table-column property="remark" width="200" :formatter="emptyFn" label="异常信息" :show-overflow-tooltip="true"></el-table-column>
        <el-table-column property="vhcNo" width="120"  :formatter="emptyFn" label="车牌号"></el-table-column>
        <el-table-column property="dirverName" width="100" :formatter="emptyFn"  label="司机姓名"></el-table-column>
        <el-table-column property="dirverMobile" width="130" :formatter="emptyFn"  label="司机电话"></el-table-column>
        <el-table-column property="reportingLocation" width="200" :formatter="emptyFn"  label="上报位置" :show-overflow-tooltip="true"></el-table-column>
        <el-table-column prop="reportTime" width="190" label="上报时间" :formatter="emptyFn"></el-table-column>
        <el-table-column property="orderNo" width="200" label="订单号" :formatter="emptyFn"></el-table-column>
        <el-table-column property="shipperTenantName" :formatter="emptyFn" width="260" label="货主"></el-table-column>

        <el-table-column property="deliverPlace" width="200" :formatter="emptyFn"  label="发货地" :show-overflow-tooltip="true"></el-table-column>
        <el-table-column property="receivingPlace" :formatter="emptyFn" width="200"  label="卸货地" :show-overflow-tooltip="true"></el-table-column>
      </el-table>
    </div>
    <!-- 分页 -->
    <div>
      <el-pagination background
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="searchFrom.pageNo"
        :page-sizes="[25,50,100]"
        :page-size="searchFrom.pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total">
      </el-pagination>
    </div>
     <!-- 运单详情 -->
    <el-dialog  title="运单详情"  :visible.sync="dialogXQ" width="1100px" class="detail" :close-oni-click-modal="false" @close="closeDialog" :close-on-press-escape="false" center>
        <el-form :inline="true" ref="XQFrom" enctype="multipart/form-data" :model="goodform"   class="demo-form-inline" label-width="110px" size="mini">
          <div class="addressBox">
            <h4 class="title">
              <span><i class="fa fa-envelope iconFont" aria-hidden="true"></i>收发货信息</span>
            </h4>
            <div class="box1">
                <div class="item">
                  <div class="box1T" style="color:#0c46a2"><i class="el-icon-location"></i>(发){{goodform.deliverCompany}}</div>
                  <div class="box1B"><span>{{goodform.deliverPerson}}</span><span>{{goodform.deliverPhone}}</span><span>{{goodform.deliverAddress}}</span></div>
                </div>
                <div class="item">
                  <div class="box1T" style="color:#F56C6C" > <i class="el-icon-location"></i>(收){{goodform.receivingCompany}}</div>
                  <div class="box1B"><span>{{goodform.receivingPerson}}</span><span>{{goodform.receivingPhone}}</span><span>{{goodform.receivingAddress}}</span></div>
                </div>
            </div>
             <hr>
          </div>
          <div class="addressBox">
            <h4 class="title">
                <span><i class="fa fa-cubes iconFont" aria-hidden="true"></i>货物信息</span>
              </h4>
              <div>
            <el-form-item label="货物类型:"  class="jiage" prop="productType">
              <span>{{goodform.productTypeName}}</span>
            </el-form-item>
            <el-form-item label="调度量:"  class="jiage" prop="weight">
              <span>{{goodform.weight}}</span><span class="">{{goodform.unitMeasurement}}</span>
            </el-form-item>
           <el-form-item label="装车量:"  class="jiage" prop="weight">
              <span>{{goodform.loadingWeight}}</span><span class="">{{goodform.unitMeasurement}}</span>
            </el-form-item>
            <el-form-item label="卸车量:"  class="jiage" prop="weight">
              <span>{{goodform.unloadingWeight}}</span><span class="">{{goodform.unitMeasurement}}</span>
            </el-form-item>
            </div>
            <hr>
          </div>
          <div class="addressBox">
            <h4 class="title">
              <span><i class="fa fa-calculator iconFont" aria-hidden="true"></i>费用相关</span>
            </h4>
          <div>
              <el-table :data="feiyongList" ref="detailTable"     bordersize="mini" class="table"  style="width: 100%" center border >
                  <el-table-column type="index" width="55" label="序号"></el-table-column>
                  <el-table-column property="jjyj" width="160"   label="计价依据"></el-table-column>
                  <el-table-column property="jjfs"  label="计价方式"></el-table-column>
                  <el-table-column property="weight" width="120" label="数量"></el-table-column>
                  <el-table-column property="danjia" width="120" label="单价"></el-table-column>
                  <el-table-column property="zongji" width="100" label="总计(元)"></el-table-column>
              </el-table>
          </div>
          <hr>
          </div>
          <div class="addressBox" v-if="goodform.goodList">
            <h4 class="title">
                <span><i class="fa fa-bars iconFont" aria-hidden="true"></i>货物明细</span>
              </h4>
              <div>
                <el-table :data="goodform.goodList" ref="detailTable"    bordersize="mini" class="table" height="300"  style="width: 100%" center border >
                  <el-table-column property="cargoBarcode" width="160"   label="捆包号"></el-table-column>
                  <el-table-column property="productName" :formatter="emptyFn" label="品名"></el-table-column>
                  <el-table-column property="brand" width="120" :formatter="emptyFn" label="牌号"></el-table-column>
                  <el-table-column property="specification" width="140" :formatter="emptyFn"  :show-overflow-tooltip="true" label="规格"></el-table-column>
                  <el-table-column property="model" width="120" label="材质"></el-table-column>
                  <el-table-column property="weight" width="100" label="重量(吨)"></el-table-column>
                  <el-table-column property="position" width="100"  :formatter="emptyFn" label="库位"></el-table-column>
              </el-table>
            </div>
            <hr>
          </div>
          <div class="addressBox">
            <h4 class="title">
                <span><i class="fa fa-truck iconFont" aria-hidden="true"></i>承运信息</span>
              </h4>
              <div>
            <el-form-item label="车牌号:"  class="jiage" prop="productType">
              <span>{{goodform.vhcNo}}</span>
            </el-form-item>
            <el-form-item label="司机姓名:"  class="jiage" prop="weight">
              <span>{{goodform.dirverName}}</span>
            </el-form-item>
           <el-form-item label="联系电话:"  class="jiage" prop="weight">
              <span>{{goodform.dirverMobile}}</span>
            </el-form-item>
            </div>
            <hr>
          </div>
           <div class="addressBox">
            <h4 class="title">
                <span><i class="fa fa-clock-o iconFont" aria-hidden="true"></i>时间记录</span>
              </h4>
              <div>
                <div>
                    <el-form-item label="发布时间:" prop="createTime">
                        <el-date-picker
                          v-model="goodform.createTime"
                          format="yyyy-MM-dd HH:mm:ss"
                          value-format="timestamp"
                          type="datetime"
                          :readonly="true"
                            placeholder=""
                        ></el-date-picker>
                  </el-form-item>
                    <el-form-item label="发布人:"  class="jiage" prop="createUserName">
                    <span>{{goodform.createUserName}}</span>
                  </el-form-item>
                </div>
                <div v-if="goodform.receivingTime">
                   <el-form-item label="接单时间:" prop="receivingTime">
                        <el-date-picker
                          v-model="goodform.receivingTime"
                          format="yyyy-MM-dd HH:mm:ss"
                          value-format="timestamp"
                          type="datetime"
                          :readonly="true"
                            placeholder=""
                        ></el-date-picker>
                  </el-form-item>
                </div>
                <div  v-if="goodform.outTime">
                   <el-form-item label="装车时间:" prop="outTime">
                        <el-date-picker
                          v-model="goodform.outTime"
                          format="yyyy-MM-dd HH:mm:ss"
                          value-format="timestamp"
                          type="datetime"
                          :readonly="true"
                            placeholder=""
                        ></el-date-picker>
                  </el-form-item>
                </div>
                <div  v-if="goodform.arrivalTime">
                   <el-form-item label="到货时间:" prop="arrivalTime">
                        <el-date-picker
                          v-model="goodform.arrivalTime"
                          format="yyyy-MM-dd HH:mm:ss"
                          value-format="timestamp"
                          type="datetime"
                          :readonly="true"
                            placeholder=""
                        ></el-date-picker>
                  </el-form-item>
                </div>
                <div  v-if="goodform.acceptanceTime">
                   <el-form-item label="验收时间:" prop="acceptanceTime">
                        <el-date-picker
                          v-model="goodform.acceptanceTime"
                          format="yyyy-MM-dd HH:mm:ss"
                          value-format="timestamp"
                          type="datetime"
                          :readonly="true"
                            placeholder=""
                        ></el-date-picker>
                  </el-form-item>
                </div>
                <div  v-if="goodform.signingTime">
                   <el-form-item label="签收时间:" prop="signingTime">
                        <el-date-picker
                          v-model="goodform.signingTime"
                          format="yyyy-MM-dd HH:mm:ss"
                          value-format="timestamp"
                          type="datetime"
                          :readonly="true"
                            placeholder=""
                        ></el-date-picker>
                  </el-form-item>
                </div>
                <div  v-if="goodform.evaluateTime">
                   <el-form-item label="评价时间:" prop="evaluateTime">
                        <el-date-picker
                          v-model="goodform.evaluateTime"
                          format="yyyy-MM-dd HH:mm:ss"
                          value-format="timestamp"
                          type="datetime"
                          :readonly="true"
                            placeholder=""
                        ></el-date-picker>
                  </el-form-item>
                </div>
            </div>
            <hr>
          </div>
          <div class="addressBox" v-if="goodform.isChangeCar==1">
            <h4 class="title">
                <span><i class="fa fa-truck iconFont" aria-hidden="true"></i>换车记录</span>
              </h4>
              <div>
            <div>
              <el-form-item label="原车牌号:"  class="jiage" prop="productType">
                <span>{{goodform.carLogList[0].vhcNo}}</span>
              </el-form-item>
              <el-form-item label="原司机姓名:"  class="jiage" prop="weight">
                <span>{{goodform.carLogList[0].driverName}}</span><span class=""></span>
              </el-form-item>
              <el-form-item label="原联系电话:"  class="jiage" prop="weight">
                <span>{{goodform.carLogList[0].dirverMobile}}</span><span class=""></span>
              </el-form-item>
            </div>
            <div>
              <el-form-item label="现车牌号:"  class="jiage" prop="productType">
                <span>{{goodform.carLogList[0].currentVhcNo}}</span>
              </el-form-item>
              <el-form-item label="现司机姓名:"  class="jiage" prop="weight">
                <span>{{goodform.carLogList[0].currentDirverName}}</span><span class=""></span>
              </el-form-item>
              <el-form-item label="现联系电话:"  class="jiage" prop="weight">
                <span>{{goodform.carLogList[0].currentDirverMobile}}</span><span class=""></span>
              </el-form-item>
              <el-form-item label="换车时间:" prop="">
                        <el-date-picker
                          v-model="goodform.carLogList[0].endTime"
                          format="yyyy-MM-dd HH:mm:ss"
                          value-format="timestamp"
                          type="datetime"
                          :readonly="true"
                            placeholder=""
                        ></el-date-picker>
                  </el-form-item>
            </div>
            </div>
          </div>
        </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogXQ = false">取 消</el-button>
      </span>
   </el-dialog>
   <el-dialog title="查看图片" :close-on-click-modal="false" :visible.sync="addMarkLookBox" width="50%" center>
      <div v-if="imgData.length == 0" class="noImg">暂无图片</div>
      <div class="img_box" v-for="(item,index) in imgList" :key="index">
        <el-image :src="item" :preview-src-list="getSrcList(index)" class="tupian" ></el-image>
      </div>
    </el-dialog>
</div>
</template>
<script>
import { getBtn } from '@/utils/getButton'
import { wayDetail } from '@/api/soc-customer'
import { orderDetail, getExceptionReportingList, sWayExsReportingPicture } from '@/api/soc-stock'
import { emptyFn, toFixed } from '@/utils/util'
import { exportExcel } from '@/utils/fileDownXlsx.js'
export default {
  data () {
    return {
      isDisable: false,
      toFixed: toFixed,
      emptyFn: emptyFn,
      CHFrom: {},
      deiverFrom: {
        pageNo: 1,
        pageSize: 50
      },
      h: 500,
      searchFrom: {
        pageNo: 1,
        pageSize: 50
      },
      tableList: [],
      total: 0,
      loading: false,
      dialogXQ: false,
      goodform: {},
      yclx: [
        { val: '', name: '请选择' },
        { val: '堵车', name: '堵车' },
        { val: '车辆故障', name: '车辆故障' },
        { val: '天气异常', name: '天气异常' },
        { val: '交通事故', name: '交通事故' },
        { val: '其他', name: '其他' }
      ],
      feiyongList: [
        { jjyj: '', jjfs: '', weight: '', danjia: '', zongji: '' },
        { jjyj: '', jjfs: '', weight: '', danjia: '', zongji: '' }
      ],
      btnFlg: [],
      btnIdArr: ['009M0I0100', '009M0I0200', '009M0I0300'],
      reportDateTime: [],
      addMarkLookBox: false,
      imgData: [],
      imgList: []
    }
  },
  created () {
    this.btnFlg = getBtn(this.btnIdArr, '/unusual')
    this.getList(this.searchFrom)
  },
  mounted () {
    let h = this.$refs.searchBox.offsetHeight
    let pH = document.documentElement.clientHeight
    this.h = (pH - h - 98) + 'px'
  },
  methods: {
    // 点击图片放大
    getSrcList (index) {
      return this.imgList.slice(index).concat(this.imgList.slice(0, index))
    },
    // 导出
    exportFn () {
      this.searchFrom.reportTimeStart = this.reportDateTime[0]
      this.searchFrom.reportTimeEnd = this.reportDateTime[1]
      let form = this.searchFrom
      exportExcel(
        this.global.orderName + '/exceptionReporting/exportInventoryList',
        form,
        '异常风险列表'
      )
      this.isDisable = true
      setTimeout(() => {
        this.isDisable = false // 点击一次时隔两秒后才能再次点击
      }, 2000)
    },
    // 运单详情
    detailFn (row) {
      this.dialogXQ = true
      wayDetail({ businessNo: row.wayNo }).then(res => {
        this.goodform = res
        let formData = new FormData()
        formData.append('id', row.orderId)
        this.feiyongList[0].jjyj = '调度量'
        this.feiyongList[1].jjyj = '装车量'
        orderDetail(formData).then(orderRes => {
          this.feiyongList[0].jjfs = orderRes.publishPricingMethod == 1 ? '按吨' : '按单'
          this.feiyongList[1].jjfs = orderRes.publishPricingMethod == 1 ? '按吨' : '按单'
          this.feiyongList[0].weight = `${res.weight.toString()}${res.unitMeasurement}`
          this.feiyongList[1].weight = res.loadingWeight ? `${res.loadingWeight.toString()}${res.unitMeasurement}` : '-'
          this.feiyongList[0].danjia = orderRes.publishPricingMethod == 1 ? `${orderRes.publishTonPrice}元/${res.unitMeasurement}` : '-'
          this.feiyongList[1].danjia = orderRes.publishPricingMethod == 1 ? `${orderRes.publishTonPrice}元/${res.unitMeasurement}` : '-'
          this.feiyongList[0].zongji = res.fatePrice
          if (orderRes.publishPricingMethod == 2) {
            this.feiyongList[1].zongji = res.fatePrice
          } else {
            this.feiyongList[1].zongji = res.loadingWeight ? this.toFixed(accMul(res.loadingWeight, orderRes.publishTonPrice), 2) : '-'
          }
        })
        console.log(this.feiyongList)
      })
      function accMul (arg1, arg2) {
        var m = 0; var s1 = arg1.toString(); var s2 = arg2.toString()
        try {
          m += s1.split('.')[1].length
        } catch (e) {
        }
        try {
          m += s2.split('.')[1].length
        } catch (e) {
        }

        return Number(s1.replace('.', '')) * Number(s2.replace('.', '')) / Math.pow(10, m)
      }
    },
    // 点击选中
    handleRowClick (row, column, event) {
      this.$refs.table.toggleRowSelection(row)
    },
    searchFn () {
      this.getList(this.searchFrom)
    },
    // 获取货物列表
    getList (searchFrom) {
      this.loading = true
      this.searchFrom.reportTimeStart = this.reportDateTime[0]
      this.searchFrom.reportTimeEnd = this.reportDateTime[1]
      getExceptionReportingList(searchFrom).then(res => {
        this.loading = false
        this.tableList = res.list
        this.total = res.total
      })
        .catch(error => {
          this.$message.error(error.message)
        })
    },
    // 每页条数
    handleSizeChange (val) {
      this.searchFrom.pageSize = val
      this.getList(this.searchFrom)
    },
    // 当前页
    handleCurrentChange (val) {
      this.searchFrom.pageNo = val
      this.getList(this.searchFrom)
    },
    closeDialog () {
      if (this.$refs.HQform !== undefined) {
        this.$refs.HQform.resetFields()
      }
      if (this.$refs.THform !== undefined) {
        this.$refs.THform.resetFields()
      }
      if (this.$refs.HTfrom !== undefined) {
        this.$refs.HTfrom.resetFields()
      }
      this.pwdFrom = {}
      this.$refs.table.clearSelection()
      this.deiverFrom = {
        pageNo: 1,
        pageSize: 50
      }
      this.CHFrom = {}
    },
    // 重置
    resetForm (formName) {
      this.reportDateTime = []
      this.searchFrom = {
        pageNo: 1,
        pageSize: 50
      }
    },
    // 时间格式化
    dateFormat: function (row, column, cellValue) {
      var t = new Date(cellValue) // row 表示一行数据, transferTime 表示要格式化的字段名称
      var month =
    t.getMonth() + 1 < 10 ? '0' + (t.getMonth() + 1) : t.getMonth() + 1
      var date = t.getDate() < 10 ? '0' + t.getDate() : t.getDate()
      var hour = t.getHours() < 10 ? '0' + t.getHours() : t.getHours()
      var minutes = t.getMinutes() < 10 ? '0' + t.getMinutes() : t.getMinutes()
      var seconds = t.getSeconds() < 10 ? '0' + t.getSeconds() : t.getSeconds()
      var str = ''
      if (cellValue == null) {
        str = '-'
      } else {
        str = t.getFullYear() + '-' + month + '-' + date + ' ' + hour + ':' + minutes + ':' + seconds
      }
      return str
      // return t.getFullYear() + "-" + (t.getMonth() + 1) + "-" + t.getDate(); // 年月日
    },
    // 时间格式化
    dateFormat1: function (row, column, cellValue) {
      var t = new Date(cellValue) // row 表示一行数据, transferTime 表示要格式化的字段名称
      var month =
    t.getMonth() + 1 < 10 ? '0' + (t.getMonth() + 1) : t.getMonth() + 1
      var date = t.getDate() < 10 ? '0' + t.getDate() : t.getDate()
      var str = ''
      if (cellValue == null) {
        str = '-'
      } else {
        str = t.getFullYear() + '-' + month + '-' + date
      }
      return str
      // return t.getFullYear() + "-" + (t.getMonth() + 1) + "-" + t.getDate(); // 年月日
    },
    lookImage (row) {
      this.addMarkLookBox = true
      sWayExsReportingPicture({
        wayId: row.wayId,
        reportId: row.id
      }).then(res => {
        this.imgList = []
        this.imgData = res.reportImgs
        this.imgList = res.reportImgs.map(item => item.fileUrlOSS)
      })
        .catch(error => {
          this.$message.error(error.message)
        })
    }
  }
}
</script>
<style scoped lang='less'>
.searchBox{
  display: flex;
}
.searchBox .el-date-editor{
      width: 350px!important;
}
/deep/.el-input.is-disabled .el-input__inner{
    border: none;
    background-color: #dcedff;
    color: #606266;
}
.box1 span{
  margin-left: 10px;
  font-size: 12px;
}
.imgBox{
  margin: 22px 10px;
  ul{
    display: flex;
    padding-left: 0;
    li{
         width: 160px;
    height: 160px;
    list-style: none;
    margin-right: 10px;
      img{
        width:100%;
        height:100%
      }
    }
  }
}
.detail  /deep/.el-input__inner{
  border:none;
  padding: 0;
}
.hidden /deep/.el-upload--picture-card{
  display: none;
}
.detail  /deep/.el-form-item--mini.el-form-item{
    margin-bottom: 0px;
}
.hidden /deep/.el-upload--picture-card{
  display: none;
}
/deep/.el-input.is-disabled .el-input__inner{
  background: #fff;
}
.box1{
  display: flex;
  padding-left: 20px;
  .item{
    max-width: 48%;
    margin-left: 10px;
    font-size: 14px;
  }
  .box1T{
    margin-bottom: 10px;
    font-weight: bold;
  }
  .box1B{
    display: flex;
    flex-wrap: wrap;
    span{
      margin-right: 20px;
      line-height: 26px;
    }
  }
}
/deep/.detail .el-date-editor .el-input__inner{
  border:none;
}
 .addressBox /deep/.el-input__suffix,.addressBox /deep/.el-input__icon{
   display: none;
 }
 .img_box {
  width: 200px;
  height: 200px;
  display: inline-block;
  margin-right: 20px;
  // border: 1px dashed #ccc;
  padding: 5px;
  .tupian {
    width:100%;
    height: 100%;
    // max-width:100%;
    // object-fit:none;/*保留原有元素内容的长度和宽度*/
  }
}
</style>
